/* @flow */
import React from 'react';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import cx from 'classnames';
import './styles/Divider.scss';

class Divider extends React.Component {
  static propTypes = {
    size: React.PropTypes.oneOf(['small', 'medium', 'large']),
  };

  static propClasses = {
    size: {
      small: 'Divider--small',
      medium: 'Divider--medium',
      large: 'Divider--large',
    },
  };

  static defaultProps = {
    size: 'large',
  };

  render() {
    return (
      <hr className={cx('Divider', this.props.className, getPropClassesFromInstance(this))} />
    );
  }
}

export default Divider;



// WEBPACK FOOTER //
// ./src/components/Divider.jsx